import { render, staticRenderFns } from "./dialog-trashinboxoutbox.vue?vue&type=template&id=49b32c51&"
import script from "./dialog-trashinboxoutbox.vue?vue&type=script&lang=js&"
export * from "./dialog-trashinboxoutbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports